// src/Blog.js
import { useEffect, useRef, useState } from "react";

const BLOG_POSTS = [
  {
    id: "japan",
    title: "Japan",
  },
];

// All images in the blog for gallery navigation
const BLOG_IMAGES = [
  {
    "src": "/blog/japan/Japan-Trip-Full-Map.png",
    "alt": "Japan Trip Full Map",
    "caption": "We only covered a small section of Japan over my five days."
  },
  {
    "src": "/blog/japan/Japan-Trip-Monday-Map.png",
    "alt": "Japan Trip Monday Map",
    "caption": "Monday Itinerary."
  },
  {
    "src": "/blog/japan/touchdown-narita.jpeg",
    "alt": "Touchdown in Narita",
    "caption": "Touchdown in Narita."
  },
  {
    "src": "/blog/japan/mcd-narita.jpeg",
    "alt": "Instructions for the Shaka Shaka chicken at McDonald's Japan",
    "caption": "Instructions for the Shaka Shaka chicken at McDonald's Japan."
  },
  {
    "src": "/blog/japan/lawson-brian.jpeg",
    "alt": "Brian at Lawson",
    "caption": "Brian up to no good at the Kawaguchiko Lawson."
  },
  {
    "src": "/blog/japan/Japan-Trip-Tuesday-Map.png",
    "alt": "Japan Trip Tuesday Map",
    "caption": "Tuesday Itinerary."
  },
  {
    "src": "/blog/japan/mt-fuji-morning.jpeg",
    "alt": "Mt. Fuji morning view",
    "caption": "Just magnificent."
  },
  {
    "src": "/blog/japan/chureito-stop.jpeg",
    "alt": "A small shrine on the way to Chureito Pagoda",
    "caption": "One of the many stops for photos along the way to Chureito Pagoda."
  },
  {
    "src": "/blog/japan/chureito-top.jpeg",
    "alt": "Top of Chureito Pagoda",
    "caption": "At the top of the Pagoda. By this time, Mt. Fuji’s peak was completely covered by clouds."
  },
  {
    "src": "/blog/japan/Japan-Trip-Wednesday-Map.png",
    "alt": "Japan Trip Wednesday Map",
    "caption": "Wednesday Itinerary."
  },
  {
    "src": "/blog/japan/711-ninki.jpeg",
    "alt": "7-Eleven hot foods",
    "caption": "A selection of some of the many hot foods which 7-Eleven offered, with a menu that includes my beloved ninki-set."
  },
  {
    "src": "/blog/japan/711-eating.jpeg",
    "alt": "Us eating outside 7-Eleven",
    "caption": "Us eating outside the 7-Eleven. Hunger is the best spice, but whatever they put on the chicken patties might be a close second."
  },
  {
    "src": "/blog/japan/skiing-karuizawa.jpeg",
    "alt": "Skiing at Karuizawa",
    "caption": "Skiing at Karuizawa."
  },
  {
    "src": "/blog/japan/Japan-Trip-Thursday-Map.png",
    "alt": "Japan Trip Thursday Map",
    "caption": "Thursday Itinerary."
  },
  {
    "src": "/blog/japan/sensoji.jpeg",
    "alt": "Sensoji Temple",
    "caption": "Sensoji Temple."
  },
  {
    "src": "/blog/japan/gyukatsu.jpeg",
    "alt": "Gyukatsu for lunch",
    "caption": "Gyukatsu and some beers for lunch – delicious."
  },
  {
    "src": "/blog/japan/Japan-Trip-Friday-Map.png",
    "alt": "Japan Trip Friday Map",
    "caption": "Friday Itinerary."
  },
  {
    "src": "/blog/japan/Your-Name-Reenacted.png",
    "alt": "Your Name stair scene recreation",
    "caption": "How’d we do?"
  },
  {
    "src": "/blog/japan/ichiran.jpeg",
    "alt": "Ichiran ramen booth",
    "caption": "Ichiran Ramen has mastered the art of no human interaction except where absolutely necessary."
  },
  {
    "src": "/blog/japan/shibuya-sky-blur.jpeg",
    "alt": "Shibuya Sky Blur",
    "caption": "While things up there seemed to slow down, you could definitely still feel the energy of the city, a machine-like humming that never stops."
  },
  {
    "src": "/blog/japan/shibuya-sky-view-1.jpeg",
    "alt": "View of the night city skyline from Shibuya Sky",
    "caption": "View of the night city skyline from Shibuya Sky."
  },
  {
    "src": "/blog/japan/shibuya-sky-view-2.jpeg",
    "alt": "View of the buildings and sprawling roads from Shibuya Sky",
    "caption": "View of the buildings and sprawling roads from Shibuya Sky."
  },
  {
    "src": "/blog/japan/shibuya-sky-view-3.jpeg",
    "alt": "View of the lights at the top of Shibuya Sky, with the city beyond",
    "caption": "View of the lights at the top of Shibuya Sky, with the city beyond."
  },
  {
    "src": "/blog/japan/Japan-Trip-Saturday-Map.png",
    "alt": "Japan Trip Saturday Map",
    "caption": "Saturday Itinerary."
  },
  {
    "src": "/blog/japan/ghibli-museum.jpeg",
    "alt": "Us posing with the Ghibli museum statue",
    "caption": "The only place we were allowed to take photos in the Ghibli museum."
  },
  {
    "src": "/blog/japan/kawaii-snake-sign.jpeg",
    "alt": "A sign saying 'Rushing onto the train is dangerous' with a kawaii snake caught in the doors and shedding a tear",
    "caption": "Everything is so kawaii here!"
  },
  {
    "src": "/blog/japan/kawaii-people-sign.jpeg",
    "alt": "A sign with very happy people waiting in line for the subway",
    "caption": "Would you be this happy waiting in line for the subway?"
  }
];



function Blog() {
  const [openSections, setOpenSections] = useState({
    backstory: true,
    dec8: true,
    dec9: true,
    dec10: true,
    dec11: true,
    dec12: true,
    dec13: true,
    wrapup: true,
  });
  const [postsPopupOpen, setPostsPopupOpen] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [panPosition, setPanPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [hasDragged, setHasDragged] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.matchMedia('(pointer: coarse)').matches : false);
  const [loadedImages, setLoadedImages] = useState(new Set());
  const [currentImageLoaded, setCurrentImageLoaded] = useState(false);

  const galleryImageRef = useRef(null);
  const scrollPosition = useRef(0);
  const preloadedImages = useRef({});

  // Pre-load all images on mount
  useEffect(() => {
    const loadImages = async () => {
      BLOG_IMAGES.forEach((imageData) => {
        const img = new Image();
        img.src = imageData.src;
        preloadedImages.current[imageData.src] = img;
        
        img.onload = () => {
          setLoadedImages(prev => new Set([...prev, imageData.src]));
        };
        
        img.onerror = () => {
          console.error(`Failed to load image: ${imageData.src}`);
        };
      });
    };
    
    loadImages();
  }, []);

  // Update current image loaded state when the loaded images set changes
  useEffect(() => {
    if (galleryOpen) {
      setCurrentImageLoaded(loadedImages.has(BLOG_IMAGES[currentImageIndex].src));
    }
  }, [loadedImages, currentImageIndex, galleryOpen]);

  // Detect mobile devices using pointer media query
  useEffect(() => {
    const mobileQuery = window.matchMedia('(pointer: coarse)');
    const handleMobileChange = (e) => {
      setIsMobile(e.matches);
    };
    mobileQuery.addEventListener('change', handleMobileChange);
    return () => mobileQuery.removeEventListener('change', handleMobileChange);
  }, []);

  // Parse URL hash for section navigation, e.g. #japan or #dec-10
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (!hash) return;

    // Known section IDs
    const knownSections = [
      "backstory",
      "dec8",
      "dec9",
      "dec10",
      "dec11",
      "dec12",
      "dec13",
      "wrapup",
      "japan",
    ];

    if (!knownSections.includes(hash)) return;

    // Map hash to actual element ID in the DOM
    let targetId = hash;
    if (hash === "japan") {
      targetId = "blog-top";
    }

    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const handleToggleSection = (id) => {
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
    window.history.replaceState(null, "", `#${id}`);
  };

  // Helper function to find image index by alt
  const getImageIndex = (altOrIndex) => {
    // If it's a number, return it as is
    if (typeof altOrIndex === 'number') {
      return altOrIndex;
    }
    // Otherwise, find by alt
    const index = BLOG_IMAGES.findIndex(img => img.alt === altOrIndex);
    return index !== -1 ? index : 0; // Default to 0 if not found
  };

  const handleOpenImage = (altOrIndex) => {
    const index = getImageIndex(altOrIndex);
    setCurrentImageIndex(index);
    setCurrentImageLoaded(loadedImages.has(BLOG_IMAGES[index].src));
    setGalleryOpen(true);
    setIsZoomed(false);
    setZoomLevel(1);
    setPanPosition({ x: 0, y: 0 });
    scrollPosition.current = window.scrollY;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition.current}px`;
    document.body.style.width = "100%";
    document.documentElement.style.overflow = "hidden";
    // Prevent native zoom on mobile
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport && isMobile) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }
  };

  const handleCloseGallery = () => {
    setGalleryOpen(false);
    setIsZoomed(false);
    setZoomLevel(1);
    setPanPosition({ x: 0, y: 0 });
    document.body.style.overflow = "auto";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.documentElement.style.overflow = "auto";
    window.scrollTo(0, scrollPosition.current);
    // Restore viewport meta tag
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport && isMobile) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
    }
  };

  const handlePrevImage = () => {
    const newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : BLOG_IMAGES.length - 1;
    setCurrentImageIndex(newIndex);
    setCurrentImageLoaded(loadedImages.has(BLOG_IMAGES[newIndex].src));
    setIsZoomed(false);
    setZoomLevel(1);
    setPanPosition({ x: 0, y: 0 });
  };

  const handleNextImage = () => {
    const newIndex = currentImageIndex < BLOG_IMAGES.length - 1 ? currentImageIndex + 1 : 0;
    setCurrentImageIndex(newIndex);
    setCurrentImageLoaded(loadedImages.has(BLOG_IMAGES[newIndex].src));
    setIsZoomed(false);
    setZoomLevel(1);
    setPanPosition({ x: 0, y: 0 });
  };

  const handleImageClick = () => {
    // Only allow zoom on desktop
    if (isMobile) {
      return;
    }
    
    // Only toggle zoom if we didn't just drag
    if (hasDragged) {
      setHasDragged(false);
      return;
    }
    
    if (isZoomed) {
      setIsZoomed(false);
      setZoomLevel(1);
      setPanPosition({ x: 0, y: 0 });
    } else {
      setIsZoomed(true);
      setZoomLevel(3.5);
    }
  };

  const handleMouseDown = (e) => {
    if (isZoomed) {
      setIsDragging(true);
      setHasDragged(false);
      setDragStart({
        x: e.clientX - panPosition.x,
        y: e.clientY - panPosition.y
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && isZoomed) {
      setHasDragged(true);
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;
      setPanPosition(constrainPan(newX, newY));
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    if (isZoomed && e.touches.length === 1) {
      setIsDragging(true);
      setHasDragged(false);
      setDragStart({
        x: e.touches[0].clientX - panPosition.x,
        y: e.touches[0].clientY - panPosition.y
      });
    }
  };

  const handleTouchMove = (e) => {
    if (isDragging && isZoomed && e.touches.length === 1) {
      setHasDragged(true);
      const newX = e.touches[0].clientX - dragStart.x;
      const newY = e.touches[0].clientY - dragStart.y;
      setPanPosition(constrainPan(newX, newY));
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  // Constrain pan position to prevent dragging past image edges (desktop only)
  const constrainPan = (newX, newY) => {
    if (!galleryImageRef.current || isMobile) {
      return { x: newX, y: newY };
    }

    const img = galleryImageRef.current;
    const imgRect = img.getBoundingClientRect();
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;
    
    // Calculate the zoomed dimensions
    const zoomedWidth = imgRect.width * zoomLevel;
    const zoomedHeight = imgRect.height * zoomLevel;
    
    // Calculate max pan distances
    const maxPanX = Math.max(0, (zoomedWidth - containerWidth) / 2);
    const maxPanY = Math.max(0, (zoomedHeight - containerHeight) / 2);
    
    // Constrain the pan position
    const constrainedX = Math.max(-maxPanX, Math.min(maxPanX, newX));
    const constrainedY = Math.max(-maxPanY, Math.min(maxPanY, newY));
    
    return { x: constrainedX, y: constrainedY };
  };

  // Inline styles (no reliance on index.css except fonts / base)
  const styles = {
    page: {
      minHeight: "100vh",
      backgroundColor: "#eeede3ff",
      color: "#111",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    header: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: 64,
      backgroundColor: "#FAF7F0",
      opacity: 1,
      borderBottom: "1px solid #e0ded6",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 20px",
      zIndex: 1000,
    },
    logo: {
      fontFamily: "'Fredoka One', 'Nunito', system-ui, sans-serif",
      fontSize: 26,
      fontWeight: 'normal',
      color: "#111",
      textDecoration: "none",
      cursor: "pointer",
      flex: "1",
    },
    headerRight: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      flex: "1",
      justifyContent: "flex-end",
      fontWeight: 700,
      fontSize: 22,
      cursor: "pointer",
    },
    mainOuter: {
      marginTop: 80,
      padding: "16px 16px 48px 16px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      boxSizing: "border-box",
    },
    mainInner: {
      maxWidth: 750,
      width: "100%",
      backgroundColor: "#FAF7F0",
      borderRadius: 16,
      padding: "24px 40px 40px 40px",
      boxSizing: "border-box",
      boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
    },
    h1: {
      marginTop: 16,
      marginBottom: 24,
      fontSize: 28,
    },
    introP: {
      marginTop: 0,
      marginBottom: 12,
      lineHeight: 1.6,
    },
    section: {
      marginTop: 24,
      marginBottom: 8,
      clear: "both",
      scrollMarginTop: 80,
    },
    sectionHeader: {
      fontSize: 20,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      userSelect: "none",
    },
    chevron: {
      marginRight: 8,
      width: 20,
      height: 20,
      transition: "transform 0.2s ease",
      cursor: "pointer",
    },
    chevronExpanded: {
      marginRight: 8,
      width: 20,
      height: 20,
      transform: "rotate(90deg)",
      transition: "transform 0.2s ease",
      cursor: "pointer",
    },
    sectionBody: {
      marginTop: 8,
      lineHeight: 1.5,
      fontSize: 15,
      color: "#222",
    },
    imageRight: {
      float: "right",
      width: "40%",
      marginLeft: 16,
      marginBottom: 12,
      textAlign: "center",
    },
    imageLeft: {
      float: "left",
      width: "40%",
      marginRight: 16,
      marginBottom: 12,
      textAlign: "center",
    },
    imageFull: {
      width: "100%",
      margin: "12px 0",
      textAlign: "center",
    },
    imageGallery: {
      width: "100%",
      display: "flex",
      gap: "12px",
      margin: "12px 0",
      flexWrap: "nowrap",
    },
    galleryItem: {
      flex: "1 1 0",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
    },
    img: {
      width: "100%",
      borderRadius: 8,
      display: "block",
    },
    figcaption: {
      fontSize: 13,
      color: "#555",
      marginTop: 4,
      fontStyle: "italic",
      lineHeight: 1.3,
    },
    spacer: {
      textAlign: "center",
      color: "#505050ff",
      margin: "32px 0",
      fontSize: 16,
      letterSpacing: "0px",
    },
    overlay: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.4)",
      zIndex: 900,
    },
    popup: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FAF7F0",
      borderRadius: 12,
      padding: 16,
      width: 280,
      boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
      zIndex: 950,
      boxSizing: "border-box",
    },
    popupClose: {
      position: "absolute",
      top: 8,
      right: 8,
      border: "none",
      background: "transparent",
      fontSize: 18,
      cursor: "pointer",
    },
    popupTitle: {
      margin: 0,
      marginBottom: 8,
      fontSize: 18,
    },
    popupList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    popupListItem: {
      padding: "6px 0",
    },
    popupLink: {
      color: "#0070f3",
      textDecoration: "none",
      cursor: "pointer",
    },
    responsiveIframeWrapper: {
      position: "relative",
      width: "100%",
      paddingBottom: "56.25%", // 16:9
      height: 0,
      overflow: "hidden",
      borderRadius: 12,
      boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
    },
    iframe: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      border: "none",
    },
    galleryModal: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.95)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      padding: 10,
      boxSizing: "border-box",
    },
    galleryContainer: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    galleryHeader: {
      flex: "2",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 16px",
      minHeight: 0,
      position: "relative",
    },
    galleryTitle: {
      color: "#fff",
      fontSize: 24,
      fontWeight: 600,
      margin: 0,
    },
    galleryImageContainer: {
      flex: "6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      position: "relative",
    },
    galleryImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      cursor: "zoom-in",
      transition: "transform 0.3s ease",
      userSelect: "none",
      WebkitTouchCallout: "none",
    },
    galleryImageZoomed: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      cursor: "zoom-out",
      transition: "none",
      userSelect: "none",
      WebkitTouchCallout: "none",
    },
    galleryImageDragging: {
      cursor: "grabbing",
    },
    galleryBottomBar: {
      flex: "2",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      minHeight: 0,
      position: "relative",
    },
    galleryCaption: {
      color: "#fff",
      fontSize: 16,
      fontStyle: "italic",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 80px",
      lineHeight: 1.4,
    },
    galleryNav: {
      position: "absolute",
      background: "rgba(255, 255, 255, 0.18)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      border: "1px solid rgba(255, 255, 255, 0.35)",
      color: "#fff",
      fontSize: 20,
      cursor: "pointer",
      padding: 0,
      width: 42,
      height: 42,
      borderRadius: "8px",
      transition: "background 0.2s, border 0.2s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      lineHeight: 1,
    },
    galleryNavLeft: {
      left: 20,
    },
    galleryNavRight: {
      right: 20,
    },
    galleryClose: {
      position: "absolute",
      right: 16,
      top: "50%",
      transform: "translateY(-50%)",
      background: "rgba(255, 255, 255, 0.18)",
      color: "#fff",
      border: "1px solid rgba(255, 255, 255, 0.35)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      fontSize: 20,
      padding: 0,
      cursor: "pointer",
      borderRadius: "8px",
      transition: "background 0.2s, border 0.2s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 42,
      height: 42,
      lineHeight: 1,
    },
    clickableImage: {
      cursor: "pointer",
    },
    loadingSpinner: {
      position: "absolute",
      width: 60,
      height: 60,
      border: "4px solid rgba(255, 255, 255, 0.2)",
      borderTop: "4px solid #fff",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    loadingContainer: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
    },
  };

  const handleBlogTitleClick = () => {
    setPostsPopupOpen(true);
  };

  const handleSelectPost = (postId) => {
    if (postId === "japan") {
      const el = document.getElementById("blog-top");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      window.history.replaceState(null, "", "#japan");
    }
    setPostsPopupOpen(false);
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <header style={styles.header}>
        <a
          href="https://www.reilly.fun"
          style={styles.logo}
        >
          reilly.fun
        </a>

        <div style={styles.headerRight} onClick={handleBlogTitleClick}>
          Blog: Japan 🇯🇵
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main style={styles.mainOuter}>
        <div style={styles.mainInner} id="blog-top">
          <h1 style={styles.h1}>Japan | <small>December 8-13, 2025</small></h1>
          <p style={styles.introP}>
                The Land of the Rising Sun. As someone from New York, I always thought of it as
                this mythical island on the other side of the world.
                5 days didn’t do it justice (we only covered a small section of the country),
                but I’m grateful I got the chance to go.
          </p>

          <div style={styles.imageFull}>
            <img
              src="/blog/japan/Japan-Trip-Full-Map.png"
              alt="Japan Trip Full Map"
              style={{...styles.img, ...styles.clickableImage}}
              draggable={false}
              onClick={() => handleOpenImage("Japan Trip Full Map")}
            />
            <div style={styles.figcaption}>
              <i>We only covered a small section of Japan over my five days.</i>
            </div>
          </div>

          <p style={styles.introP}> Here’s a journal of my trip, with some reflections weaved
            throughout. Click on any image to open the gallery. You can also click section titles
            to collapse or expand them.</p>
          <p style={{...styles.introP, lineHeight: 1.3}}> <small><i>Note: If you'd like some
            background music on{" "}
            <a
              href="https://www.youtube.com/watch?v=WCCovrKvAtU"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube
            </a>
            {" "}or{" "}
            <a
              href="https://open.spotify.com/playlist/37i9dQZF1EIf0f4Xz0vVZi?si=6ab41245ee034345"
              target="_blank"
              rel="noopener noreferrer"
            >
              Spotify
            </a>
            , feel free.</i></small> </p>

          {/* Backstory */}
          <section style={styles.section} id="backstory">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("backstory")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.backstory ? styles.chevronExpanded : styles.chevron}
                title={openSections.backstory ? "Collapse section" : "Expand section"}
              />
              Backstory
            </h2>
            {openSections.backstory && (
              <div style={styles.sectionBody}>
                <p> Brian, a homie I've known since middle school, had planned in April 2025 to
                      visit a family friend in Japan that December. I had also wanted to go to 
                      Japan for some time, and so we carved out a few days (December 8-13) for the
                      two of us to engage in a bit of tomfoolery around Tokyo. On December 13th, we
                      would part ways – me flying back to NYC and him staying in Japan to meet up
                      with his family friend. </p>
                <p> We booked our flights in May 2025. Brian is based in Wisconsin but often visits
                      his hometown in New York, so we arranged to fly from Newark Airport together.
                      We then sent Reels to each other until November, a month before our trip,
                      when we realized we still had zero planning done. The Ghibli museum's{" "}
                      <a
                        href="https://en.japantravel.com/article/ghibli-museum-how-to-get-tickets/71834"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        infamous ticket drop schedule
                      </a>
                      {" "}(described as the "Mad Max of ticket sales") snapped us out of our
                      procrastination, as we were determined to snag those. They only drop once a
                      month, and even if you arrive at the website exactly on time, you still get a
                      random place in the waitlist that could be 30 minutes or longer, after which
                      all of the tickets for the good entry times would have disappeared. (Granted,
                      the 9 devices we used between the two of us might've been overkill, but we
                      got the tickets.) In the last three weeks leading up to the trip, a few
                      FaceTime calls allowed us to finalize our lodging reservations and cobble
                      together a rough itinerary. </p>
                <p> Kevin Kelly, in his wonderful{" "}
                      <a
                        href="https://kk.org/thetechnium/50-years-of-travel-tips/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i>50 Years of Travel Tips</i>
                      </a>
                      {" "}post, suggests a “Laser-Back” approach when traveling. “When you arrive in
                      a new country, immediately proceed to the farthest, most remote, most
                      distant place you intend to reach during the trip… Then once you reach your
                      furthest point, unpack, explore, and work your way slowly back to the big
                      city, wherever your international departure airport is.” The purpose is to
                      throw yourself into “Very Different Otherness, the maximum difference that
                      you will get on this trip,” then “when you arrive in the city after a week
                      or so traveling in this strangeness, and maybe without many of the luxuries
                      you are used to, you suddenly see the city the same way the other folks
                      around you do … the bright lights, and smooth shopping streets, and
                      late-night eateries dazzle you, and you embrace the city with warmth and
                      eagerness.” I ended up accidentally following this advice, but it worked out well.</p>
                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Dec 8 */}
          <section style={styles.section} id="dec8">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("dec8")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.dec8 ? styles.chevronExpanded : styles.chevron}
                title={openSections.dec8 ? "Collapse section" : "Expand section"}
              />
              December 8, 2025 - Welcome to Japan
            </h2>
            {openSections.dec8 && (
              <div style={styles.sectionBody}>

                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/Japan-Trip-Monday-Map.png"
                    alt="Japan Trip Monday Map"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Japan Trip Monday Map")}
                  />
                  <div style={styles.figcaption}>
                    <i>Monday Itinerary.</i>
                  </div>
                </div>
                
                <p> I pulled an all-nighter in hot anticipation of the trip. Jet lag was already
                      going to be tough, so what was there to lose? I got to the airport way too
                      early, met up with Brian, and we boarded the plane. Then, liftoff.</p>
                <p> The flight was good – pleasant even. I had to get up and stretch my legs a
                      few times but slept a fair bit, interrupted only by the
                      meals. I asked one of the flight attendants if I could have more food, and he
                      delighted me with <i>two whole trays</i> of pasta, which I gladly wolfed
                      down. I think he started to judge me when I asked for more pretzels after
                      that. </p>

                <div style={styles.imageLeft}>
                  <img
                    src="/blog/japan/touchdown-narita.jpeg"
                    alt="Touchdown in Narita"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Touchdown in Narita")}
                  />
                  <div style={styles.figcaption}>
                    <i>Touchdown in Narita.</i>
                  </div>
                </div>

                <p> Upon arriving at Tokyo's Narita airport, I noticed that everyone is very kind,
                      and I'm curious if that kindness has shaped (or been shaped by) their kawaii
                      culture, where everything is cute-ified. The population was also quite
                      homogeneous and I could barely tell the difference between rich and poor.
                      Everyone was stylish. </p>

                <div style={styles.imageRight}>
                  <img
                    src="/blog/japan/mcd-narita.jpeg"
                    alt="Instructions for the Shaka Shaka chicken at McDonald's Japan"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Instructions for the Shaka Shaka chicken at McDonald's Japan")}
                  />
                  <div style={styles.figcaption}>
                    <i>Instructions for the Shaka Shaka chicken at McDonald's Japan.</i>
                  </div>
                </div>

                <p> We hit a McDonald’s meal and it was delightful. Shrimp filet sandwich,
                      Shaka Shaka chicken, teriyaki burger, beef stew pie – what a scrumptious
                      selection. The rest of the day was spent traveling to our Airbnb near Mt.
                      Fuji. We took the Skyliner express train to Nippori (one of the 23 wards of
                      Tokyo), then the subway to Shinjuku (another Tokyo ward where we had Wendy’s
                      – we really can’t help it, we’re so American), then the bus to Kawaguchiko
                      Station, where we saw the{" "}
                      <a
                        href="https://www.timeout.com/tokyo/news/the-mt-fuji-barrier-at-lawson-in-kawaguchiko-is-back-up-again-081525"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        iconic and controversial Lawson
                      </a>
                      {" "}and bought some stuff to snack on (my first experience of many with the
                      lovely Japanese convenience stores). American 7-Elevens could use an update. </p>

                <div style={styles.imageLeft}>
                  <img
                    src="/blog/japan/lawson-brian.jpeg"
                    alt="Brian at Lawson"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Brian at Lawson")}
                  />
                  <div style={styles.figcaption}>
                    <i>Brian up to no good at the Kawaguchiko Lawson.</i>
                  </div>
                </div>

                <p> The Airbnb was very cozy and we enjoyed the mattresses on the tatami mats
                    (Japanese mats made out of rush grass and rice straw). Who needs a bed frame,
                    anyways? </p>
                
                <div style={styles.spacer}>{isMobile ? "—— ● ——" : "——————— ● ———————"}</div>
              </div>
            )}
          </section>

          {/* Dec 9 */}
          <section style={styles.section} id="dec9">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("dec9")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.dec9 ? styles.chevronExpanded : styles.chevron}
                title={openSections.dec9 ? "Collapse section" : "Expand section"}
              />
              December 9, 2025 - Spiritual enrichment
            </h2>
            {openSections.dec9 && (
              <div style={styles.sectionBody}>

                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/Japan-Trip-Tuesday-Map.png"
                    alt="Japan Trip Tuesday Map"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Japan Trip Tuesday Map")}
                  />
                  <div style={styles.figcaption}>
                    <i>Tuesday Itinerary.</i>
                  </div>
                </div>

                <p> "Do you want Mt. Fuji in the background instead?" We woke up for our weekly 5K
                      run (which had, in the past few months, become something of a tradition) and
                      asked a passerby to take a photo of us in front of the Airbnb. We must have
                      looked at him like he had two heads until we turned to where he was pointing
                      and all of a sudden time froze still. </p>
                <p> (Some context: we had read online that Mt. Fuji can be elusive, not only for
                      climbing but also just to see. It’s often hidden behind clouds, and the
                      climbing season for Mt. Fuji is only from early July to early September.
                      It was December – well outside of that range. We already knew that we wouldn’t be
                      able to climb it, but we were half expecting it to not be visible, either.) </p>
                <p> We stared into the distance and the most beautiful mountain I have ever seen in
                      my life was staring back at us. Words don’t do it justice – even a picture only
                      tells a part of the story. The fresh air against your skin, breathing its
                      purity into your lungs, footsteps on a gravel road being the only sound for
                      miles. You need a few moments just to acknowledge its presence and pay your
                      due respects. </p>
                <p> I began to understand what the Transcendentalists meant when they believed
                      nature to be not just a background but also a divine reflection of the human
                      spirit, a unique mirror to the soul. Here was this grandiose, eternal wonder
                      in all its majesty, and who were we but tiny ants in comparison, both in
                      space and time? This mountain, glorious yet tranquil, looming yet inviting, a
                      medium between the earth and the skies. A mountain that had seen many summers
                      and winters, that would live to see countless more revolutions around the sun.
                      As I had my being and my very humanity wrenched into consciousness, I
                      thought: <i>How can one not be humbled? How can one not be infinitely
                      inspired?</i> </p>
                <p> I will surely come back to this mountain, but I wonder how much my life will
                      have changed. What new perspectives will I bring? What new things will it
                      teach me?</p>
                <p> The 5K run, with all of its slows and stops for reflections and photos, took
                      way longer than it should. At the same time, I’ll probably remember that run
                      for the rest of my life. </p>

                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/mt-fuji-morning.jpeg"
                    alt="Mt. Fuji morning view"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Mt. Fuji morning view")}
                  />
                  <div style={styles.figcaption}>
                    <i>Just magnificent.</i>
                  </div>
                </div>

                <p> After showering and checking out of the Airbnb, we started walking towards our
                      next stop. Japan has somewhere around 5 million vending machines, with most
                      of them outdoors, and we,{" "}
                      <a
                        href="https://edition.cnn.com/style/article/japan-vending-machines-eiji-ohashi"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        like everyone else
                      </a>
                      , became obsessed with them. </p>

                <div style={styles.imageRight}>
                  <img
                    src="/blog/japan/chureito-stop.jpeg"
                    alt="A small shrine on the way to Chureito Pagoda"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("A small shrine on the way to Chureito Pagoda")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      One of the many stops for photos along the way to Chureito Pagoda.
                    </i>
                  </div>
                </div>

                <p> Lugging our suitcases across town and up the 398 steps of the Chureito Pagoda,
                      a peace memorial built in 1963, must have been an odd sight – several folks
                      we passed were
                      laughing or wide-eyed. (Luckily, there was a road that also led to the
                      Pagoda, but it very much felt like we were disturbing the peace with our
                      noisy suitcase wheels against the pavement.) </p>

                <div style={styles.imageLeft}>
                  <img
                    src="/blog/japan/chureito-top.jpeg"
                    alt="Top of Chureito Pagoda"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Top of Chureito Pagoda")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      At the top of the Pagoda. By this time, Mt. Fuji’s peak was completely
                      covered by clouds.
                    </i>
                  </div>
                </div>

                <p> We then walked along a road and up some stairs to a little, lonely bus stop
                      on the side of the highway. After booking two tickets, we got on the next bus
                      back to Shinjuku (the same Tokyo ward where we had Wendy's the night prior).
                      It was nice to get out of the cold. </p>
                <p> Some yummy udon noodles for dinner, and then it was onto the Shinkansen
                      (bullet train) to Karuizawa, a small town about 100 miles northwest of Tokyo.
                      Our hotel had an onsen (hot spring), which we spent the rest of the evening
                      relaxing in. It felt wonderful for both the body and the soul, and Brian and
                      I chatted for a long time, moving from the indoor to the outdoor onsen at
                      some point. I was reminded of the introspective, late-night conversations we
                      used to have back when we were roommates in college. </p>
                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Dec 10 */}
          <section style={styles.section} id="dec10">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("dec10")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.dec10 ? styles.chevronExpanded : styles.chevron}
                title={openSections.dec10 ? "Collapse section" : "Expand section"}
              />
              December 10, 2025 - Skiing
            </h2>
            {openSections.dec10 && (
              <div style={styles.sectionBody}>

                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/Japan-Trip-Wednesday-Map.png"
                    alt="Japan Trip Wednesday Map"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Japan Trip Wednesday Map")}
                  />
                  <div style={styles.figcaption}>
                    <i>Wednesday Itinerary.</i>
                  </div>
                </div>
                
                <div style={styles.imageRight}>
                  <img
                    src="/blog/japan/711-ninki.jpeg"
                    alt="7-Eleven hot foods"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("7-Eleven hot foods")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      A selection of some of the many hot foods which 7-Eleven offered, with a
                      menu that includes my beloved ninki-set.
                    </i>
                  </div>
                </div>
                
                <p> We realized shortly after we woke up that none of the stores in Karuizawa opened
                      until 10am, and the hotel breakfast didn’t seem very appealing to us for the
                      price. Ranting for 15 minutes about how Japan needed to be more industrious
                      only made us hungrier. We had developed a real love for the food at konbini
                      (Japanese convenience stores), so much so
                      that we walked 30 minutes to a 7-Eleven because the nearest one was
                      closed. Brian told me once that hunger is the best spice, and as I munched
                      on my ninki set (daikon radish, egg, noodles, and grilled fishcake all in a
                      hot broth), I couldn’t help but agree. Their chicken patties were also to die
                      for – you can almost taste the love with which they treat their chickens. </p>

                <div style={styles.imageRight}>
                  <img
                    src="/blog/japan/711-eating.jpeg"
                    alt="Us eating outside 7-Eleven"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Us eating outside 7-Eleven")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      Us eating outside the 7-Eleven. Hunger is the best spice, but whatever they
                      put on the chicken patties might be a close second.
                    </i>
                  </div>
                </div>

                <p> Skiing was great, but there were a limited number of trails open because it
                      was so early in the skiing season. We originally targeted Yuzawa for skiing,
                      but their mountains didn’t open until late December, after our last day.
                      Still, it was awesome to ski the slopes of Japan, and they also had a mini
                      terrain park where I got some big air. </p>

                <div style={styles.imageLeft}>
                  <img
                    src="/blog/japan/skiing-karuizawa.jpeg"
                    alt="Skiing at Karuizawa"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Skiing at Karuizawa")}
                  />
                  <div style={styles.figcaption}>
                    <i>Skiing at Karuizawa.</i>
                  </div>
                </div>

                <p> Karuizawa had a shopping mall too, so we spent the rest of the day there.
                      They had every major store you could think of, but unfortunately at
                      major prices as well. We didn't see a ton of Japan-exclusive items,
                      either. </p>
                <p> Afterwards, we took the bullet train back to Tokyo and had dinner at a
                      hole-in-the-wall steakhouse near our Airbnb (the Airbnb we would stay in for
                      the rest of my time there). It felt good to finally drop our suitcases.
                      The restaurant seemed like a place where locals went to when they
                      were drunk – it was a pretty authentic experience. Cool Western theme,
                      decent steak. </p>
                <p> Everything in Tokyo seems smaller. The clothing sizes were one down, the
                      apartments don’t need much space, and our luggage took up the entire
                      passageway on the bus ride to our apartment, much to the locals’ dismay.
                      Also, people are rather quiet here. I wonder if that’s infused into the culture
                      or if it’s just because everyone else does it. (What came first, the chicken
                      or the egg?) Strangers at the ski chairlifts went solo up the mountain rather
                      than partnering up to save time. I almost wanted to break that convention and
                      sit with someone, but I figured it was better to follow the etiquette I saw.
                      No need to become someone's "disrespectful foreigner" story.</p>
                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Dec 11 */}
          <section style={styles.section} id="dec11">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("dec11")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.dec11 ? styles.chevronExpanded : styles.chevron}
                title={openSections.dec11 ? "Collapse section" : "Expand section"}
              />
              December 11, 2025 - Sensoji Temple &amp; Ginza
            </h2>
            {openSections.dec11 && (
              <div style={styles.sectionBody}>
                
                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/Japan-Trip-Thursday-Map.png"
                    alt="Japan Trip Thursday Map"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Japan Trip Thursday Map")}
                  />
                  <div style={styles.figcaption}>
                    <i>Thursday Itinerary.</i>
                  </div>
                </div>
                
                <p> Breakfast at{" "}
                      <a
                        href="https://www.instagram.com/reel/DQcT5CAiPKl/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Denny’s
                      </a>
                      {" "}(yes, that Denny's, though the ones in Japan are owned by the same
                      parent as 7-Eleven's), where we had some familiar sausage and egg dishes. We
                      also tried natto (fermented soybean) which apparently is what made{" "}
                      <a
                        href="https://www.mlb.com/news/shohei-ohtani-popularity-everywhere-in-japan"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Shohei Ohtani
                      </a>
                      {" "}big and strong. It didn’t take long to realize we could never be him.
                      The acrid smell and the slimy texture (a bit like okra) made it feel more
                      like a frat hazing ritual than a snack. I ate as much as I could. Then it was
                      back to the Airbnb for a little nap. </p>
                <p> It was around noon when we set out for Sensoji
                      temple (Tokyo’s oldest temple, built in the 7th century AD). We took in the
                      architecture, paid our respects, and then munched on some snacks from the
                      stands in the area. </p>

                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/sensoji.jpeg"
                    alt="Sensoji Temple"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Sensoji Temple")}
                  />
                  <div style={styles.figcaption}>
                    <i>Sensoji Temple.</i>
                  </div>
                </div>

                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/gyukatsu.jpeg"
                    alt="Gyukatsu for lunch"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Gyukatsu for lunch")}
                  />
                  <div style={styles.figcaption}>
                    <i>Gyukatsu and some beers for lunch – delicious.</i>
                  </div>
                </div>

                <p> We headed over to Ginza to do some shopping, and I spent way too much at
                      Uniqlo’s flagship store, which has 12 stories and discounted prices. We then
                      took the subway to teamLab Planets, a museum with intriguing and often
                      interactive exhibits. Some played
                      with textures and tactile features, whether for your hands or your feet, some
                      had visual and auditory components, and all of them came with explanations
                      that did a great job tying the tangible to the metaphysical, the meaning
                      behind it, what it hoped to accomplish. Here's an example: </p>
                <blockquote> <strong>Soft Black Hole - Your Body Becomes a Space that Influences Another Body</strong>
                      <br />
                      In modern life we are surrounded by flat hard surfaces, so that in our daily
                      lives we have lost consciousness of our bodies, we have forgotten them. In
                      natural forests flat ground does not exist. This installation is a space to
                      remind us of the body that we have forgotten in everyday life, and to make us
                      more conscious of our body mass. </blockquote>
                <p> We were exhausted after the museum, but we still needed dinner. We walked with our heavy
                      shopping bags to a conveyor belt sushi restaurant, and that gave us back the life
                      we needed. We subwayed back and made it home around 11pm, when I promptly
                      collapsed on my bed and didn’t wake up again until 6 hours later. </p>
                <div style={styles.spacer}>
                  <i>
                    No sky and no earth<br />
                    At all. Only the vastness<br />
                    Falls incessantly.<br />
                  </i> 
                    <small><small><br />— Haiku by Hashin (1864-?), translated by Daniel C. Buchanan, possibly modified by me</small></small>
                </div>
                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Dec 12 */}
          <section style={styles.section} id="dec12">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("dec12")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.dec12 ? styles.chevronExpanded : styles.chevron}
                title={openSections.dec12 ? "Collapse section" : "Expand section"}
              />
              December 12, 2025 - Shibuya
            </h2>
            {openSections.dec12 && (
              <div style={styles.sectionBody}>
                
                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/Japan-Trip-Friday-Map.png"
                    alt="Japan Trip Friday Map"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Japan Trip Friday Map")}
                  />
                  <div style={styles.figcaption}>
                    <i>Friday Itinerary.</i>
                  </div>
                </div>

                <p> We started the day on the later side. First stop: Suga Shrine, the location of
                      the iconic staircase scene in the movie <i>Your Name</i>. It’s one of Brian’s
                      favorite animes, maybe even one of his favorite movies in general, and he
                      showed it to me during our senior year of college. We posed on the stairs for
                      an obligatory photo. </p>

                <div style={{...styles.imageFull, marginLeft: "16.5%", marginRight: "16.5%", width: "67%"}}>
                  <img
                    src="/blog/japan/Your-Name-Reenacted.png"
                    alt="Your Name stair scene recreation"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Your Name stair scene recreation")}
                  />
                  <div style={styles.figcaption}>
                    <i>How’d we do?</i>
                  </div>
                </div>

                <div style={styles.imageRight}>
                  <img
                    src="/blog/japan/ichiran.jpeg"
                    alt="Ichiran ramen booth"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Ichiran ramen booth")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      Ichiran Ramen has mastered the art of no human interaction except where
                      absolutely necessary.
                    </i>
                  </div>
                </div>

                <p> Then we subwayed over to Shibuya and got on the waitlist for Ichiran Ramen. In
                      the meantime, we visited Tower Records and some other nearby stores. We
                      headed back to Ichiran after being notified that our spot was ready, and it
                      was worth the wait.
                      They’ve once again mastered the art of no human interaction except where
                      absolutely necessary. Single stalls, wooden curtains in front of you that
                      only open when needed, and you only ever see the hands of your waiter – not
                      their face. It was still a sick vibe, though. Later, we did some more
                      shopping at various stores. Some of the vintage/thrift shops had some real
                      hidden gems. The vibrant and effervescent streets made me feel like I was in
                      a video game.* </p>

                <p> Up next: Shibuya sky. An unforgettable view – it really shows you how much of a
                      megalopolis Tokyo is. Here’s a haiku I wrote while up there: </p>
                <div style={styles.spacer}>
                  <i>
                    Frosting on the glass<br />
                    Buzzing twinkling lights beyond<br />
                    High in Shibuya
                  </i> 
                </div>
                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/shibuya-sky-blur.jpeg"
                    alt="Shibuya Sky Blur"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Shibuya Sky Blur")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      While things up there seemed to slow down, you could definitely still feel
                      the energy of the city, a machine-like humming that never stops.
                    </i>
                  </div>
                </div>
                
                <p> Finally, Don Quixote, Japan's massive "we sell everything" store. They’re not
                      joking when they say it’s overstimulating. 8 floors of densely-packed shelves
                      that never end. I ended up getting some candy packs, drinks, and little
                      collectibles for folks back home. At some point I ran outside to take a
                      breather because I was dehydrated and the{" "}
                      <a
                        href="https://www.youtube.com/watch?v=1zl88Aieecw"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Don Quixote song
                      </a>
                      {" "}was playing for the billionth time – it was all really starting to get
                      to me. Don Quixote is not for the weak. </p>
                <p> We were on the verge of missing the last subway (they only run until 12:30am or
                      so) and having a night out in Shibuya, but our better selves dismissed the
                      thought when we realized we could still make it home. 5 frantic Google
                      searches, 2 subway transfers, and 1 hearty FamilyMart meal later, we were
                      back at the apartment. Sleep at last. </p>
                <div style={styles.spacer}>——————— ● ———————</div>
                <p style={{fontSize: "14px"}}> *It's no surprise that many elements of Japanese
                      culture have found a warm reception in the US, but thinking about the
                      gaming world was especially interesting during my trip. Beyond
                      Nintendo creating Mario and being an absolute behemoth in the video game
                      industry worldwide, the geography of Japan makes for such picturesque
                      settings. <i>Ghost of Tsushima</i> and <i>Sekiro</i> are games that are set
                      in Japan during the samurai era, and the futuristic feel of Tokyo reminded me
                      of games like <i>Mirror’s Edge</i> and <i>Cyberpunk 2077</i>. Tokyo street
                      racing culture has a{" "}
                      <a
                        href="https://www.youtube.com/watch?v=qG0UwUeKhAg"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        reputation that precedes itself
                      </a>
                      , with Tokyo being “the birthplace of a car culture that has spread across
                      the world.” Along the way, it's inspired countless racing games and movies (
                      <a
                        href="https://www.youtube.com/watch?v=pbYMReX2ci4"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i>FF Tokyo Drift</i>
                      </a>
                      {" "}hints at its aura). The subways also made us feel like we were in{" "}
                      <i>Exit 8</i>. It was impressive to see the place that inspired it all. </p>

                <div style={styles.imageGallery}>
                  <div style={{...styles.galleryItem, flex: "0.75 1 0"}}> {/* 4284:5712 = 0.75:1 ratio */}
                    <img
                      src="/blog/japan/shibuya-sky-view-1.jpeg"
                      alt="View of the night city skyline from Shibuya Sky"
                      style={{...styles.img, ...styles.clickableImage, ...styles.galleryImage}}
                      draggable={false}
                      onClick={() => handleOpenImage("View of the night city skyline from Shibuya Sky")}
                    />
                  </div>
                  <div style={{...styles.galleryItem, flex: "0.75 1 0"}}> {/* 4284:5712 = 0.75:1 ratio */}
                    <img
                      src="/blog/japan/shibuya-sky-view-2.jpeg"
                      alt="View of the buildings and sprawling roads from Shibuya Sky"
                      style={{...styles.img, ...styles.clickableImage, ...styles.galleryImage}}
                      draggable={false}
                      onClick={() => handleOpenImage("View of the buildings and sprawling roads from Shibuya Sky")}
                    />
                  </div>
                  <div style={{...styles.galleryItem, flex: "1.33 1 0"}}> {/* 1536:2048 = 1.33:1 ratio */}
                    <img
                      src="/blog/japan/shibuya-sky-view-3.jpeg"
                      alt="View of the lights at the top of Shibuya Sky, with the city beyond"
                      style={{...styles.img, ...styles.clickableImage, ...styles.galleryImage}}
                      draggable={false}
                      onClick={() => handleOpenImage("View of the lights at the top of Shibuya Sky, with the city beyond")}
                    />
                  </div>
                </div>

                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Dec 13 */}
          <section style={styles.section} id="dec13">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("dec13")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.dec13 ? styles.chevronExpanded : styles.chevron}
                title={openSections.dec13 ? "Collapse section" : "Expand section"}
              />
              December 13, 2025 - Last day &amp; Ghibli museum
            </h2>
            {openSections.dec13 && (
              <div style={styles.sectionBody}>
                
                <div style={styles.imageFull}>
                  <img
                    src="/blog/japan/Japan-Trip-Saturday-Map.png"
                    alt="Japan Trip Saturday Map"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Japan Trip Saturday Map")}
                  />
                  <div style={styles.figcaption}>
                    <i>Saturday Itinerary.</i>
                  </div>
                </div>
                
                <p> I woke up around 8am and found Brian snacking on some stuff from the konbini.
                      Packing was a breeze because I had arrived in Japan with half of my suitcase
                      empty (I knew I would be bringing things back). I was able to fit all of the
                      clothing and souvenirs I'd bought, with room to spare. </p>
                <p> On our way to the Studio Ghibli museum, I struck it lucky with the gacha-pon
                      machines (vending machines that dispense a random capsule toy) by getting the
                      keychain that I wanted. Why are these things so addictive? </p>

                <div style={styles.imageRight}>
                  <img
                    src="/blog/japan/ghibli-museum.jpeg"
                    alt="Us posing with the Ghibli museum statue"
                    style={{...styles.img, ...styles.clickableImage}}
                    draggable={false}
                    onClick={() => handleOpenImage("Us posing with the Ghibli museum statue")}
                  />
                  <div style={styles.figcaption}>
                    <i>
                      The only place we were allowed to take photos in the Ghibli museum.
                    </i>
                  </div>
                </div>

                <p> The Ghibli museum was the perfect blend of nostalgia and whimsy. We arrived
                      around 11:30am and were slightly limited on time because I had to leave for
                      the airport at 12:30pm. However, an hour was still enough to see many
                      exhibits on Ghibli movies both familiar and unfamiliar. We also got to watch
                      a museum-exclusive short film, which was moving and made me reflect on what
                      it means to grow up. A classroom full of children decide to embark on a
                      voyage. Blocks, chairs, and poles become a great big ship, and kids become
                      sailors. They ride through high tides and thunderstorms, almost capsizing
                      along the way. They spot a whale and try to hunt it, only to befriend it
                      later. Through a magnificent stroke of luck, the ship arrives safely back to
                      land, where they're greeted with laurels from the children who stayed on
                      shore. Kids have this bold imagination to dream up entire worlds. Who would
                      want to give that up?</p>
                <p> My journey to the airport turned into a slight mess because I took the local
                      train instead of the express. Luckily, I met someone else who was
                      also heading to the airport, and we were able to ease our stresses with some
                      conversation about our lives. (We both spoke English, though he was from the
                      UK.) After getting to my terminal, I went through check-in and security very
                      smoothly and had some free time to convert my unused Japanese yen back to
                      US dollars. I also had fun buying tax-free boxes of treats near my gate. </p>

                <div style={styles.imageGallery}>
                  <div style={{...styles.galleryItem, flex: "0.75 1 0"}}> {/* 1536:2048 = 0.75:1 ratio */}
                    <img
                      src="/blog/japan/kawaii-snake-sign.jpeg"
                      alt="A sign saying 'Rushing onto the train is dangerous' with a kawaii snake caught in the doors and shedding a tear"
                      style={{...styles.img, ...styles.clickableImage, ...styles.galleryImage}}
                      draggable={false}
                      onClick={() => handleOpenImage("A sign saying 'Rushing onto the train is dangerous' with a kawaii snake caught in the doors and shedding a tear")}
                    />
                    <div style={styles.figcaption}>
                      <i>
                        Everything is so kawaii here!
                      </i>
                    </div>
                  </div>
                  <div style={{...styles.galleryItem, flex: "1.33 1 0"}}> {/* 5712:4284 = 1.33:1 ratio */}
                    <img
                      src="/blog/japan/kawaii-people-sign.jpeg"
                      alt="A sign with very happy people waiting in line for the subway"
                      style={{...styles.img, ...styles.clickableImage, ...styles.galleryImage}}
                      draggable={false}
                      onClick={() => handleOpenImage("A sign with very happy people waiting in line for the subway")}
                    />
                    <div style={styles.figcaption}>
                      <i>
                        Would you be this happy waiting in line for the subway?
                      </i>
                    </div>
                  </div>
                </div>

                <p> As I said my last arigato, I reflected on how my expectations compared with
                      reality (e.g., kawaii culture is way bigger than I thought; trains aren’t{" "}
                      <i>always</i> on time – just way more often than the NYC subway; bowing isn't
                      as prevalent as I expected). I also thought about how Linus Torvalds, the
                      creator of the Linux operating system, said in a{" "}
                      <a
                        href="https://youtu.be/mfv0V1SxbNA?si=XfHkD3B9THoMShLM&t=2331"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        recent video
                      </a>
                      {" "}that he doesn’t tend to enjoy big cities, but still enjoys Tokyo. “Tokyo
                      is one of those cities that, even as a big city, does things differently.”
                      Once can only guess at whether it’s the cleanliness, the convenience, the
                      courtesy, the homogeneity, the air, the spirit, the cuisine, the surrounding
                      landscapes, or all of the above. Japan had been enchanting, and I
                      grew to appreciate its paradoxical feel. As the cities rush forward into the
                      future, places like Sensoji temple and Mt. Fuji stay still, indifferent,
                      preserving the timelessness of the island for tomorrow's rising sun. </p>
                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Wrapped / summary */}
          <section style={styles.section} id="wrapup">
            <h2
              style={styles.sectionHeader}
              onClick={() => handleToggleSection("wrapup")}
            >
              <img
                src="/chevron.png"
                alt="Toggle section"
                style={openSections.wrapup ? styles.chevronExpanded : styles.chevron}
                title={openSections.wrapup ? "Collapse section" : "Expand section"}
              />
              Japan Wrapped
            </h2>
            {openSections.wrapup && (
              <div style={styles.sectionBody}>
                <p> <strong>Favorite food:</strong> Ninki-set from 7-Eleven<br />
                      <strong>Favorite drink:</strong> Ilohas peach-flavored water<br />
                      <strong>Favorite convenience store:</strong> FamilyMart (they sold cool
                        socks) </p>
                <p> <strong>Most spiritual experience:</strong> Seeing Mt. Fuji<br />
                      <strong>Least spiritual experience:</strong> Buying two quarter-zips from
                        Uniqlo and realizing I am as performative as the next guy<br />
                      <strong>Coolest Japan-exclusive experience:</strong> Seeing an unreleased
                        Ghibli short film at their museum </p>
                <p> <strong>Most underrated:</strong> Bathrooms in every subway station<br />
                      <strong>Most unexpectedly fun:</strong> Gacha-pon machines<br />
                      <strong>Biggest regret:</strong> Not buying more boxes of Japanese treats at
                        the tax-free airport store </p>
                <div style={styles.spacer}>——————— ● ———————</div>
              </div>
            )}
          </section>

          {/* Music videos */}
          
          <p style={styles.introP}> Here's some music I enjoyed during my visit to Tower Records
            and throughout my time in Japan. </p>

          {/* YouTube video embeds */}
          <div style={{...styles.imageGallery, alignItems: "stretch", flexDirection: typeof window !== 'undefined' && window.innerWidth < 450 ? "column" : "row"}}>
            <div style={{flex: "1 1 0", display: "flex"}}>
              <div style={{...styles.responsiveIframeWrapper, width: "100%"}}>
                <iframe
                  style={styles.iframe}
                  src="https://www.youtube.com/embed/TcLLpZBWsck"
                  title="Fujii Kaze - Kirari"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div style={{flex: "1 1 0", display: "flex"}}>
              <div style={{...styles.responsiveIframeWrapper, width: "100%"}}>
                <iframe
                  style={styles.iframe}
                  src="https://www.youtube.com/embed/PDSkFeMVNFs"
                  title="RADWIMPS - Zenzenzense"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div style={{flex: "1 1 0", display: "flex"}}>
              <div style={{...styles.responsiveIframeWrapper, width: "100%"}}>
                <iframe
                  style={styles.iframe}
                  src="https://www.youtube.com/embed/QNYT9wVwQ8A"
                  title="Miki Matsubara - Stay With Me"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>

          <div style={styles.spacer}></div>

          <p style={styles.introP}> Thanks for reading and would love to hear your thoughts! </p>
          <p style={styles.introP}> <strong>-RX</strong> </p>
        </div>
      </main>

      {/* BLOG LIST POPUP */}
      {postsPopupOpen && (
        <>
          <div
            style={styles.overlay}
            onClick={() => setPostsPopupOpen(false)}
          />
          <div style={styles.popup}>
            <button
              type="button"
              style={styles.popupClose}
              onClick={() => setPostsPopupOpen(false)}
            >
              ✕
            </button>
            <h3 style={styles.popupTitle}>Blog posts</h3>
            <ul style={styles.popupList}>
              {BLOG_POSTS.map((post) => (
                <li key={post.id} style={styles.popupListItem}>
                  <span
                    onClick={() => handleSelectPost(post.id)}
                    style={styles.popupLink}
                  >
                    {post.title}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}

      {/* IMAGE GALLERY VIEWER */}
      {galleryOpen && BLOG_IMAGES.length > 0 && (
        <div 
          style={styles.galleryModal}
          onMouseMove={!isMobile ? handleMouseMove : undefined}
          onMouseUp={!isMobile ? handleMouseUp : undefined}
          onMouseLeave={!isMobile ? handleMouseUp : undefined}
          onTouchMove={!isMobile ? handleTouchMove : undefined}
          onTouchEnd={!isMobile ? handleTouchEnd : undefined}
        >
          <div style={styles.galleryContainer}>
            <div style={styles.galleryHeader}>
              <h2 style={styles.galleryTitle}>Japan: Gallery</h2>
              <button
                style={styles.galleryClose}
                onClick={handleCloseGallery}
              >
                ×
              </button>
            </div>
            <div style={styles.galleryImageContainer}>
              {!currentImageLoaded && (
                <div style={styles.loadingContainer}>
                  <div style={styles.loadingSpinner}></div>
                </div>
              )}
              <img
                ref={galleryImageRef}
                src={BLOG_IMAGES[currentImageIndex].src}
                alt={BLOG_IMAGES[currentImageIndex].alt}
                style={{
                  ...(isZoomed && !isMobile ? styles.galleryImageZoomed : styles.galleryImage),
                  ...(isDragging && !isMobile ? styles.galleryImageDragging : {}),
                  transform: isZoomed && !isMobile ? `scale(${zoomLevel}) translate(${panPosition.x / zoomLevel}px, ${panPosition.y / zoomLevel}px)` : "none",
                  opacity: currentImageLoaded ? 1 : 0,
                  transition: currentImageLoaded ? (isZoomed ? "none" : "opacity 0.3s ease") : "opacity 0.3s ease",
                  cursor: isMobile ? "default" : (isZoomed ? "zoom-out" : "zoom-in"),
                }}
                draggable={false}
                onClick={handleImageClick}
                onMouseDown={!isMobile ? handleMouseDown : undefined}
                onTouchStart={!isMobile ? handleTouchStart : undefined}
                onLoad={() => setCurrentImageLoaded(true)}
              />
            </div>
            <div style={styles.galleryBottomBar}>
              <button
                style={{...styles.galleryNav, ...styles.galleryNavLeft}}
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <div style={styles.galleryCaption}>
                {BLOG_IMAGES[currentImageIndex].caption} ({currentImageIndex + 1}/{BLOG_IMAGES.length})
              </div>
              <button
                style={{...styles.galleryNav, ...styles.galleryNavRight}}
                onClick={handleNextImage}
              >
                ›
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Blog;
